/*
 * Tabla con scroll y encabezado fijo, réplica de las tablas del HTML original
 * (th #EBEEF8 en mayúsculas, hover de filas, borde inferior por celda)
 */
import { useState } from "react";

import { htmlTheme } from "./utils/carthelp";

/**
 * Renderiza una tabla básica a partir de columnas y filas
 * @param {Object} props Propiedades del componente
 * @param {Array} props.columns Columnas [{ key, title, render, align }]
 * @param {Array} props.rows Filas de datos
 * @param {Function} props.onRowClick Callback opcional al hacer click en una fila
 * @param {Function} props.onHeaderClick Callback opcional al hacer click en un encabezado
 * @param {number} props.maxHeight Alto máximo del contenedor scrollable
 */
const Simtable = ({ columns = [], rows = [], onRowClick, onHeaderClick, maxHeight = 440 }) => {
  const bClickable = typeof onRowClick === "function";
  const bSortable = typeof onHeaderClick === "function";
  const [nHover, setHover] = useState(null);

  return (
    <div style={{ maxHeight, overflow: "auto", border: `1px solid ${htmlTheme.border}`, borderRadius: 10 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
        <thead>
          <tr>
            {columns.map((mCol) => (
              <th
                key={mCol.key}
                onClick={bSortable ? () => onHeaderClick(mCol.key) : undefined}
                style={{
                  background: "#EBEEF8",
                  color: htmlTheme.navy2,
                  textAlign: mCol.align || "left",
                  padding: "9px 10px",
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: 0.4,
                  position: "sticky",
                  top: 0,
                  whiteSpace: "nowrap",
                  cursor: bSortable ? "pointer" : "default",
                }}
              >
                {mCol.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center", color: htmlTheme.muted, padding: 16 }}>
                Sin registros
              </td>
            </tr>
          ) : (
            rows.map((mRow, nIndex) => (
              <tr
                key={nIndex}
                onClick={bClickable ? () => onRowClick(mRow) : undefined}
                onMouseEnter={() => setHover(nIndex)}
                onMouseLeave={() => setHover(null)}
                style={{ cursor: bClickable ? "pointer" : "default" }}
              >
                {columns.map((mCol) => (
                  <td
                    key={mCol.key}
                    style={{
                      padding: "8px 10px",
                      borderBottom: `1px solid ${htmlTheme.border}`,
                      textAlign: mCol.align || "left",
                      background: nHover === nIndex ? (bClickable ? "#EAF0FF" : "#F7F9FF") : "transparent",
                    }}
                  >
                    {mCol.render ? mCol.render(mRow) : mRow[mCol.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

/**
 * Punto de color de rango (réplica del .dot del HTML)
 * @param {Object} props Propiedades del componente
 * @param {string} props.color Color hex del punto
 */
export const Dotspanx = ({ color }) => (
  <span
    style={{ display: "inline-block", width: 9, height: 9, borderRadius: "50%", marginRight: 6, background: color }}
  />
);

/**
 * Valor monetario coloreado (réplica de .pos-val / .neg-val del HTML)
 * @param {Object} props Propiedades del componente
 * @param {number} props.value Valor numérico original
 * @param {string} props.text Texto formateado a mostrar
 */
export const Valspanx = ({ value, text }) => (
  <span style={{ color: value < 0 ? htmlTheme.green : htmlTheme.coralDark }}>{text}</span>
);

export default Simtable;
